
function Organizzatore({email, telefono, infoOrganizzatore, apriBanner, messaggiLength}) {

    return (<>
        <div>
            <h5 style={{ margin: '1rem' }}><b>INFO ORGANIZZATORE</b></h5>
            <div style={{ marginLeft: '1rem' }}>
                {email &&
                    <p><img src={require('../../image/icons8-nuovo-messaggio-48.png')} width="25rem" alt='' />
                        <a href={`mailto:${email}`} style={{ textDecoration: 'none', color: 'navy' }}> {email}</a>
                    </p>
                }
                {telefono &&
                    <p><img src={require('../../image/icons8-telefono-cellulare-48.png')} width="23em" alt='' />
                        <a href={`tel:+39${telefono}`} style={{ textDecoration: 'none', color: 'navy' }}> {telefono}</a>
                    </p>
                }
                {/* --------------------- BUTTON COMMENTI ------------------ */}
                <button className='btn btn-primary' onClick={() => { apriBanner('primoMessGenitore') }}
                    style={{ fontSize: 'small', fontWeight: '600' }}>
                    Messaggio
                </button>
                <span onClick={() => { apriBanner('primoMessGenitore') }}>
                    <img src={require('../../image/icons8-fumetti-con-puntini-50.png')} alt=''
                        style={{ width: '1.5em', marginLeft: '2%', cursor: 'pointer', backgroundColor: 'white' }} />
                    <span style={{ marginLeft: '.5em' }}><i>{messaggiLength}</i></span>
                </span>
            </div>
            <div>
                {/* ----------------- INFO ORGANIZZATORE ----------------- */}
                {infoOrganizzatore &&
                    <p className='mt-3 p-1'>
                        {infoOrganizzatore}
                    </p>
                }
                {!email && !telefono && !infoOrganizzatore &&
                    <p className='mt-3'>Non ci sono informazioni da mostrare</p>}
            </div>
        </div>
    </>)
}
export default Organizzatore